import React, { memo } from "react";
import { Chip } from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/system";

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ selected, theme }) => ({
  color: "#ffffff",
  padding: "10px",
  cursor: "pointer",
  ...(selected && {
    background: "#392AB6",
  }),
  ...(!selected && {
    background: "#21CCFB",
  }),
}));

function CustomChips({ label, selected, setSelected, ...props }) {
  return (
    <StyledChip
      key={label}
      label={label}
      onClick={setSelected}
      selected
      {...props}
    />
  );
}

CustomChips.propTypes = {
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  setSelected: PropTypes.func,
};
CustomChips.defaultProps = {
  label: "",
  selected: false,
  setSelected: () => {},
};
export default memo(StyledChip);
